export class GPSPosition {
    id: number;
    
    Code: string;
    Longitude: number;
    Latitude: number;
    L93X: number;
    L93Y: number;

    static mapFromJSON(json): GPSPosition {
        const gps = new GPSPosition();

        gps.Code = json.code;
        gps.L93X = json.l93X;
        gps.L93Y = json.l93Y;
        gps.Latitude = json.latitude;
        gps.Longitude = json.longitude;

        return gps;
    }
}
